export default [
  {
    path: '/app/customers',
    name: 'Customers',
    component: () => import('@/views/Admin/Customers/Index.vue'),
    meta: {
      pageTitle: 'Müşteri Kartları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_CUSTOMER_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/customers/add',
    name: 'CustomerAdd',
    component: () => import('@/views/Admin/Customers/Add.vue'),
    meta: {
      pageTitle: 'Müşteri Kartları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/customers',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_CUSTOMER_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/customers/edit/:id',
    name: 'CustomerEdit',
    component: () => import('@/views/Admin/Customers/Edit.vue'),
    meta: {
      pageTitle: 'Müşteri Kartları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/customers',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_CUSTOMER_EDIT',
      action: 'read',
    },
  },
  {
    path: '/app/customers/view/:id',
    name: 'CustomerView',
    component: () => import('@/views/Admin/Customers/View.vue'),
    meta: {
      pageTitle: 'Müşteri Kartları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/customers',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_CUSTOMER_VIEW',
      action: 'read',
    },
  },
]
